import { useQuery } from "@tanstack/react-query";
import { fetchShipsApi } from "@/API/fetchShipsApi";
import { ShipDataType } from "@/types/apiTypes";
import { useLoadingContext } from "@/hooks/contextHooks/useLoadingContext";

export const useFetchShips = (
  shipSearchTerm: string,
  selectedProjectId: string | null,
) => {
  const { startLoading, stopLoading } = useLoadingContext();

  const query = useQuery<ShipDataType[], Error>({
    queryKey: ["ships"],
    queryFn: async () => {
      startLoading();

      try {
        return await fetchShipsApi(shipSearchTerm, selectedProjectId);
      } finally {
        console.log("✅ Request completed.");
        stopLoading();
      }
    },
    retry: 1,
  });

  if (query.isFetching) {
    console.log("❌ Request overridden for ships.");
  }

  return query;
};
